import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../config';
import { LenderOptionType, ValidationReviewInventoryTableFields } from './types';

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  queryParams: string;
};
const apiClientConfig: ApiClientConfig = {
  timeout: config.validationReviewInventoryApi.requestTimeout
};
const inventoryTimeout: number = config.validationReviewInventoryApi.requestTimeout;
const validationInventoryDataUrl: string =
  config.validationReviewInventoryApi.urls.validationReview;
const insuredApprovedLenderListUrl: string =
  config.validationReviewInventoryApi.urls.insuredApprovedLenderList;
const applicationErrorReportUrl: string =
  config.validationReviewInventoryApi.urls.applicationDetail;

export const getValidationInventoryTableData = async ({
  authenticationContext,
  queryParams
}: RequestProps): Promise<ValidationReviewInventoryTableFields[]> => {
  try {
    const validationInventoryDataUrlWithParams = validationInventoryDataUrl + queryParams;
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      validationInventoryDataUrlWithParams,
      { timeout: inventoryTimeout }
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error(`Error getting inventory table data, ${err!!}`);
  }
};

export const getInsuredApprovedLenderList = async (
  authenticationContext: AuthenticationContextType
): Promise<LenderOptionType[] | null> => {
  try {
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      insuredApprovedLenderListUrl,
      { timeout: inventoryTimeout }
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data?.[0]?.lenders) ||
      null
    );
  } catch (err) {
    throw new Error(`Error getting insured approved lender list data, ${err!!}`);
  }
};
export const getApplicationErrorReport = async (
  authenticationContext: AuthenticationContextType,
  applicationId: number,
  requestUrl?: string
): Promise<any> => {
  try {
    const applicationErrorReportUrlWithParams =
      requestUrl ?? `${applicationErrorReportUrl}/${applicationId}/error-report`;
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      applicationErrorReportUrlWithParams,
      { timeout: inventoryTimeout, responseType: 'blob' }
    );
    return (
      ((response?.status === HttpResponseStatusCodes.Created ||
        response?.status === HttpResponseStatusCodes.OK) &&
        response) ||
      null
    );
  } catch (err) {
    const errorText = await err.response.data.text();
    const errorData = JSON.parse(errorText);

    throw errorData;
  }
};
